import * as React from 'react'
import { Link } from 'react-router-dom'

interface LinkListProps {
  basePath: string;
  itemKey: string;
  text: string;
  activeClassName?: string;
  className?: string;
  excludeResponses?: boolean;
}

const LinkListItem = (props:any) => {
  const { activeClassName, basePath, className, excludeResponses, itemKey } = props
  const responsesString = !excludeResponses ? '/responses' : ''
  return (
    <li>
      <Link
        activeClassName={activeClassName}
        className={className}
        to={'/admin/' + basePath + '/' + itemKey + responsesString}
      >
        {props.text}
      </Link>
    </li>
  )
}

export { LinkListItem }
